var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m9-1H7v1.556h7zm0 6.444H7V12h7zM3.5 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }